import { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { CustomContainer } from "../../atoms/DependencyHelper";
import ContentSearchBox from "../../atoms/contentSearchBox/ContentSearchBox";
import EmptyProductsContainer from "../../organisms/emptyProductsContainer/EmptyProductsContainer";
import StoreCard from "../../atoms/storeCard/storeCard";
import DropDownComponent from "../../atoms/dropDown/DropDown";
import LabelText from "../../atoms/label/LabelText";
import styles from "./SearchStoreClickAndCollect.module.scss";
import { imagePrefix } from '../../../utils/helperServices';
import getStoreLists from "../../../utils/getStoreList";
import InfoBox from "../../atoms/infoBox/InfoBox";

const SearchStoreClickAndCollect = ({
	sku,
	header,
	text,
	geoLocationIsAllowed,
	storeAddress,
	callBackSelectedStore
}) => {
	const [finalAddress, setFinalAddress] = useState();
	const [dataSize, setDataSize] = useState(3);
	const [isShowSearchResult, setIsShowSearchResult] = useState(false);
	const [storeListsFromSearch, setStoreListsFromSearch] = useState(undefined);
	const [storeAddressList, setStoreAddressList] = useState([]);
	const [serviceDown, setServiceDown] = useState(false);
	const [selectedDropdownIndex, setSelectedDropdownIndex] = useState(0);
	const [searchResult, setSearchResult] = useState(false);

	let dropdownValues;
	if (geoLocationIsAllowed) {
		dropdownValues = [
			{ label: "Distance" },
			{ label: "Alphabetical (A-Z)" },
			{ label: "Alphabetical (Z-A)" },
		];
	} else {
		dropdownValues = [
			{ label: "Alphabetical (A-Z)" },
			{ label: "Alphabetical (Z-A)" },
		];
	}

	useEffect(() => {
		if (!geoLocationIsAllowed && !finalAddress) {
			setIsShowSearchResult(false);
		} else if (finalAddress) {
			setIsShowSearchResult(true);
			storeDetailsUsingSearchedAddress(finalAddress?.geometry?.location);
		}
		setSearchResult(false);
	}, [finalAddress, geoLocationIsAllowed]);

	useEffect(() => {
		if (storeListsFromSearch &&
			storeListsFromSearch.length) {
			storeAddress = [...storeListsFromSearch];
		}

		if (storeAddress.length) {
			const selectedValue = dropdownValues[selectedDropdownIndex].label;
			storeAddress = sortSearchedResult(selectedValue, storeAddress);
		}
		setStoreAddressList(storeAddress);
	}, [storeListsFromSearch]);

	const storeCardClickHandler = (id) => {
		const selectedStore = storeAddressList[id];
		callBackSelectedStore(selectedStore);
	}

	const handleSizeChange = (size) => {
		setDataSize(size);
	}

	const handleSelect = (e) => {
		const index = dropdownValues.findIndex(item => item.label === e);
		setSelectedDropdownIndex(index);

		storeAddress = sortSearchedResult(e, storeListsFromSearch);
		setStoreAddressList(storeAddress);
	};

	const passSuggestedData = (filteredAddressData) => {
		if (filteredAddressData.length == 0) {
			setSearchResult(true);
			setStoreAddressList([]);
			setStoreListsFromSearch(undefined);
		} else {
			setSearchResult(false);
		}
	}

	const storeDetailsUsingSearchedAddress = (location) => {
		const userSelectedLocation = {
			latitude: location.lat,
			longitude: location.lng
		}
		setSearchResult(false);
		getStoreLists(userSelectedLocation, sku, setStoreListsFromSearch, setServiceDown);
	}

	const sortSearchedResult = (selectedValue, dataSource) => {
		switch (selectedValue) {
			case "Distance":
				dataSource = dataSource.sort((a, b) => {
					if (a.distance < b.distance) { return -1; }
					if (a.distance > b.distance) { return 1; }
					return 0;
				})
				break;

			case "Alphabetical (A-Z)":
				dataSource = dataSource.sort((a, b) => {
					if (a.name < b.name) { return -1; }
					if (a.name > b.name) { return 1; }
					return 0;
				})
				break;

			case "Alphabetical (Z-A)":
				dataSource = dataSource.sort((a, b) => {
					if (a.name > b.name) { return -1; }
					if (a.name < b.name) { return 1; }
					return 0;
				})
				break;
		}

		return dataSource;
	}

	const renderStoreList = () => {
		return (isShowSearchResult ?
			(
				<>
					{storeAddressList?.length ?
						(<>
							<StoreCard
								variant="searchedStore"
								handleOnClick={storeCardClickHandler}
								onSizeChange={handleSizeChange}
								data={storeAddressList}
								isFromModal={true}
								geoLocationIsAllowed={geoLocationIsAllowed}
							/>
							<div className={styles["banner"]}>
								<InfoBox
									type="info"
									imageSrc={`${imagePrefix}/assets/images/info_white.svg`}
									imageWidth="1.3125rem"
									imageHeight="1.3125rem"
									text="Please note, you’ll only be able to collect from one of these stores when your order/upgrade consists of a contract and no once-off purchase items."
								/>
							</div>
						</>) : (
							<EmptyProductsContainer
								message={"We couldn’t find any results for your search term. Please try again."}
								ctaHidden={true}
							/>
						)
					}
				</>
			) : (
				<>
					{storeAddressList?.length ?
						(<>
							<div className={styles["banner"]}>
								<InfoBox
									type="info"
									imageSrc={`${imagePrefix}/assets/images/info_white.svg`}
									imageWidth="1.3125rem"
									imageHeight="1.3125rem"
									text="Please note, you’ll only be able to collect from one of these stores when your order/upgrade consists of a contract and no once-off purchase items."
								/>
							</div>
							<label className={styles["label-style"]}>These stores close to you have stock:</label>
							<StoreCard
								variant=""
								handleOnClick={storeCardClickHandler}
								onSizeChange={handleSizeChange}
								data={storeAddressList}
								isFromModal={true}
								geoLocationIsAllowed={geoLocationIsAllowed}
							/>
						</>) : (
							<>
								{/* <EmptyProductsContainer
									message={"We couldn’t find any results for your search term. Please try again."}
									ctaHidden={true}
								/> */}
							</>
						)
					}
				</>
			));
	}

	return (
		<CustomContainer className={`search-top-container ${styles["search-top-container-collect"]}`}>
			<h5 className={styles['search-stores-header']}>{header}</h5>
			<p className={styles['search-stores-text']}>{text}</p>

			<CustomContainer className={"d-none " + styles["search-wrapper"]}>
				<CustomContainer className={"d-none " + styles["search-wrapper"]}>
					<ContentSearchBox
						className={styles["search-wrapper__input"]}
						placeholderText="Search for your store"
						icon="blue"
						variant="store-search" // address-search
						setFinalAddress={setFinalAddress}
						passSuggestedData={(filteredAddressData) => passSuggestedData(filteredAddressData)}
						analyticFormName="store addresses"
						isStoreSearch={true}
					></ContentSearchBox>
				</CustomContainer>
			</CustomContainer>
			{searchResult == true && (<CustomContainer>
				<CustomContainer className={styles["result"]}>
					<LabelText className={styles["results-count"]}>{`0 - 0 of 0 results `}</LabelText>
					<CustomContainer className={styles["dropdown-container"]}>
						<LabelText className={styles["sort-text"]}>Sort by:</LabelText>
						<DropDownComponent
							data={dropdownValues}
							customClass={styles["selection-drop-down"]}
							menuClassName="sort-menu"
							selectedValue={dropdownValues[selectedDropdownIndex].label}
							id="sort-menu"
							handleSelect={handleSelect}
						/>
					</CustomContainer>
				</CustomContainer>
				<CustomContainer className={styles["empty-wrapper"]}>
					<EmptyProductsContainer
						message={"We couldn’t find any results for your search term. Please try again."}
						ctaHidden={true}
					/>
				</CustomContainer>
			</CustomContainer>
			)}
			{serviceDown &&
				<div className={styles["banner"]}>
					<InfoBox
						type="warn"
						imageSrc={`${imagePrefix}/assets/images/icon-info.svg`}
						imageWidth="1.3125rem"
						imageHeight="1.3125rem"
						text="Looks like we’re having some technical issues. Please try again later."
					/>
				</div>
			}

			{isShowSearchResult && !searchResult && !serviceDown &&
				<CustomContainer className={styles["result"]}>
					<LabelText className={styles["results-count"]}>1-{dataSize} of {storeAddressList?.length} results </LabelText>
					<CustomContainer className={styles["dropdown-container"]}>
						<LabelText className={styles["sort-text"]}>Sort by:</LabelText>
						<DropDownComponent
							data={dropdownValues}
							customClass={styles["selection-drop-down"]}
							menuClassName="sort-menu"
							selectedValue={dropdownValues[selectedDropdownIndex].label}
							id="sort-menu"
							handleSelect={handleSelect}
						/>
					</CustomContainer>
				</CustomContainer>}

			{!serviceDown && !searchResult && renderStoreList()}
		</CustomContainer>
	);
}

SearchStoreClickAndCollect.propTypes = {
	sku: PropTypes.string,
	header: PropTypes.string,
	text: PropTypes.string,
	geoLocationIsAllowed: PropTypes.bool,
	callBackSelectedStore: PropTypes.func
}

export default SearchStoreClickAndCollect;